import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './App.css'

// Suppress React DevTools warning in development
if (import.meta.env.DEV) {
  // @ts-ignore
  const hook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (hook && hook.onCommitFiberRoot) {
    hook.onCommitFiberRoot = null;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)